import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import { TellentPosition, UpdatePositionPayload } from '@core/tellent-positions-types';

const idSelector = (position: { guid: string }) => position.guid;

const { actions, namespace, selectors, reducer } = createEntityCollectionStore<TellentPosition>()(
  'TellentPositions',
  {
    idSelector,
    customActions: adapter => {
      const _defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchCollection: state => adapter.markAsPending(state),
        createOnePessimistic: (
          state,
          payload: {
            name: string;
            correlationId: string;
          },
        ) =>
          adapter.markAsPending(state, {
            scope: null,
            entities: payload.correlationId ? [payload.correlationId] : [],
          }),
        updateOnePessimistic: (state, payload: { guid: string; position: UpdatePositionPayload }) =>
          adapter.markAsPending(state, { scope: null, entities: [payload.guid] }),
        removeOnePessimistic: (state, payload: { guid: string }) =>
          adapter.markAsPending(state, { scope: null, entities: [payload.guid] }),
        removeOnePessimisticSuccess: (state, payload: { data: { guid: string } }) =>
          adapter.removeOne(state, payload.data.guid),
      };
    },
  },
);

export {
  selectors as TellentPositionsSelectors,
  reducer as TellentPositionsReducer,
  actions as TellentPositionsActions,
  namespace as TellentPositionsNamespace,
};
